module.exports = __webpack_public_path__ + "img/icon-mobile.0ba05972.svg";